module.exports = __webpack_public_path__ + "static/global-seo-img-1f0865e3a72c252bcd7e8e8937bfab93.png";